import { defineComponent as n, openBlock as r, createElementBlock as o, normalizeClass as t, createElementVNode as i, renderSlot as s } from "vue";
import { _ as a } from "../../../_plugin-vue_export-helper-dad06003.js";
const l = n({
  name: "VContentChip",
  props: {
    backgroundColor: {
      type: String,
      default: "grey-200",
      validator: (e) => ["grey-200", "green-deep", ""].includes(e)
    },
    size: {
      type: String,
      default: "m",
      validator: (e) => ["s", "m"].includes(e)
    }
  }
});
function c(e, p, d, m, u, f) {
  return r(), o("div", {
    class: t(["hobi-content-chip tw-rounded-full tw-inline-block tw-items-center tw-mb-2 tw-mr-2", e.backgroundColor === "grey-200" ? "tw-bg-gray-200" : "tw-bg-green"])
  }, [
    i("div", {
      class: t(["hobi-content-chip__content", e.size === "s" ? "tw-py-0 tw-px-2" : "tw-py-2 tw-px-4"])
    }, [
      s(e.$slots, "default")
    ], 2)
  ], 2);
}
const b = /* @__PURE__ */ a(l, [["render", c]]);
export {
  b as default
};
